// import AuditionsStar from "./Pages/AnudionsStar/AuditionsStar";
import JoinNoWMeetUp from "./Pages/MeetupEventsStar/Content/JoinNoWMeetUp";
import StarMeetUpEvent from "./Pages/MeetupEventsStar/StarMeetUpEvent";
import StarMeetUpEventListCompleted from "./Pages/MeetupEventsStar/StarMeetUpEventCompleted";
import StarMeetUpEventCreate from "./Pages/MeetupEventsStar/StarMeetupEventCreate";
import StarMeetUpEventList from "./Pages/MeetupEventsStar/StarMeetUpEventList";
import NotifyRecord from "./Pages/NotifySuperstar/NotifyGreetingsRecord";
// import CricketJersey from "./Pages/Souvenir/CricketJersey/CricketJersey";
import StarScheduleView from "./Pages/StarLiveChat/Content/StarScheduleView";
import StarAddSessionContent from "./Pages/StarLiveChat/StarAddSessionContent";

import JoinLiveChat from "./Pages/StarLiveChat/RegisterUser/StarRegistertUser";

//=========================== Star Simple Post=============================
import AllPost from "../../Screen/SuperStar/Post/AllPost";
import ApprovedPost from "../../Screen/SuperStar/Post/ApprovedPost";
import CreatePost from "../../Screen/SuperStar/Post/CreatePost";
import EditPost from "../../Screen/SuperStar/Post/EditPost";
import PendingPost from "../../Screen/SuperStar/Post/PendingPost";
import PostDetails from "../../Screen/SuperStar/Post/PostDetalis";

//<============================= Star Live Chat Section =========================>
import LiveChatContent from "../../Screen/SuperStar/LiveChat/LiveChatContent";
import LiveChatCreate from "../../Screen/SuperStar/LiveChat/LiveChatCreate";
import LiveChatDetails from "../../Screen/SuperStar/LiveChat/LiveChatDetails";
import LiveChatEdit from "../../Screen/SuperStar/LiveChat/LiveChatEdit";
import LiveChatType from "../../Screen/SuperStar/LiveChat/LiveChatType";

//=========================== Star QnA Section =============================
import QnaMsgBox from "../../Screen/SuperStar/FanGroup/Content/QnaMsgBox";
import LiveQnA from "../../Screen/SuperStar/QnA/LiveQnA";
import PendingQnA from "../../Screen/SuperStar/QnA/PendingQnA";
import QnaCompleted from "../../Screen/SuperStar/QnA/QnaCompleted";
import QnACreate from "../../Screen/SuperStar/QnA/QnACreate";
import QnaDashboard from "../../Screen/SuperStar/QnA/QnaDashboard";
import QnADetails from "../../Screen/SuperStar/QnA/QnADetails";
import StarEditQna from "./Pages/SuperstarQnA/StarEditQna";

//=========================== Star FanGroup=============================
import AcceptedFan from "../../Screen/SuperStar/FanGroup/AcceptedFan";
import InvitationFan from "../../Screen/SuperStar/FanGroup/InvitationFan";
import RejectedFan from "../../Screen/SuperStar/FanGroup/RejectedFan";
import CreateLearningSession from "../../Screen/SuperStar/LearningSession/Content/CreateLearningSession";
import AcceptDetail from "./Pages/FanGroupStar/Content/AcceptDetail";
import AcceptedDetails from "./Pages/FanGroupStar/Content/AcceptedDetails";
import FanGroupCreate from "./Pages/FanGroupStar/Content/FanGroupCreate";
import FanGroupLive from "./Pages/FanGroupStar/Content/FanGroupLive";
import IgnoredDetails from "./Pages/FanGroupStar/Content/IgnoredDetails";
import InvitationDetails from "./Pages/FanGroupStar/Content/InvitationDetails";
import RejectedDetails from "./Pages/FanGroupStar/Content/RejectedDetails";
import FanGroupHome from "./Pages/FanGroupStar/FanGroupHome";
import FanBaseStar from "./Pages/FanGroupStar/Home/FanBaseStar";

//=========================== Star Auction Section =============================

import ApprovedOrDecline from "./Pages/StarShowcase/Auction/SuperstarProductList/Auction/ApprovedOrDecline";
import EditProductAuction from "./Pages/StarShowcase/Auction/SuperstarProductList/Auction/EditProductAuction";
import PendingProductList from "./Pages/StarShowcase/Auction/SuperstarProductList/Auction/PendingProductList";
import SoldProductList from "./Pages/StarShowcase/Auction/SuperstarProductList/Auction/SoldProductList";
import UnSoldProductList from "./Pages/StarShowcase/Auction/SuperstarProductList/Auction/UnsoldProductList";

//<============================= Star Learning Session =========================>
import LearningSession from "../../Screen/SuperStar/LearningSession/AllPost";
import ApprovedLearningSession from "../../Screen/SuperStar/LearningSession/ApprovedPost";
import CompletedLearningSession from "../../Screen/SuperStar/LearningSession/CompletedPost";
import LearningSessionEvaluationDetails from "../../Screen/SuperStar/LearningSession/Content/EvaluationPostDetails";
import PendingLearningSessionDetails from "../../Screen/SuperStar/LearningSession/Content/PendingPostDetails";
import EvaluationLearningSession from "../../Screen/SuperStar/LearningSession/EvaluationPost";
import PendingLearningSession from "../../Screen/SuperStar/LearningSession/PendingPost";

import EditLearningSession from "../../Screen/SuperStar/LearningSession/Content/EditSessionContent";
import LearningSessionLiveStream from "../../VideoCall";
import StarApprovedContentDetails from "./Pages/StarLiveChat/StarApprovedContentDetails";

import StarUpcomingEvent from "./Pages/StarUpcomingEvent/StarUpcomingEvent";
import StarVideoChat from "./Pages/StarVideoChat/StarVideoChat";
import SuperstarGreetings from "./Pages/SuperstarPageGreetings/SuperstarPageGreetings";
import SuperstarGreetingsVideoRecord from "./Pages/VidoUploadPage/VidoUpload";
import SuperstarGreetingsVideoUpload from "./Pages/VidoUploadPage2.js/VidoUploadPage2";
// import DashboardStar from "./StarHader/DashboardStar";
import LiveChatScheduleList from "./Pages/StarLiveChat/Content/LiveChatScheduleList/LiveChatScheduleList";
import StarLiveChatApprove from "./Pages/StarLiveChat/StarLiveChatApprove";

import RequestLearn from "../../Screen/SuperStar/LearningSession/Request/RequestLearn";
import RequestLearnEvent from "../../Screen/SuperStar/LearningSession/Request/RequestLearnEvent";
import RequestLearnList from "../../Screen/SuperStar/LearningSession/Request/RequestLearnList";
// import ApprovedLearnList from "./Pages/StarLearningSession/Content/Approved/ApprovedLearnList";
// import ApprovedLearnSlide from "./Pages/StarLearningSession/Content/Approved/ApprovedLearnSlide";
// import ApprovedLearnEvent from "./Pages/StarLearningSession/Content/Approved/ApprovedLearnEvent";
import StarLearnSessionTime from "../../Screen/SuperStar/LearningSession/Request/StarLearnSessionTime";
// import AppLearnSessionTime from "./Pages/StarLearningSession/Content/Approved/AppLearnSessionTime";
// import VideoLearnSession from "./Pages/StarLearningSession/Content/Approved/VideoLearnSession";
import StarNotifySchedule from "../Admin/Home/Pages/AdminGreetings/NotifyGreetings/Content/NotifySchedule";
import StarVideoJoin from "./Dashboard/Content/StarVideoJoin";
import StarDashEvent from "./Dashboard/StarDashEvent";
import StarEventCategory from "./Dashboard/StarEventCategory";
import StarEventRequesting from "./Dashboard/StarEventRequesting";
import StarMainDashboard from "./Dashboard/StarMainDashboard";
import StartNotifyScheduleView from "./Pages/NotifySuperstar/Content/StartNotifyScheduleView";
import AddProductAuctionSuperstar from "./Pages/StarShowcase/Auction/AddProductAuctionSuperstar/AddProductAuctionSuperstar";
import ConfirmOrEditSuperAuction from "./Pages/StarShowcase/Auction/AddProductAuctionSuperstar/ConfimrOrEditSuperAuction/ConfirmOrEditSuperAuction";
import SuperstarLiveBidding from "./Pages/Superstar-Souvenir/SuperstarLiveBidding/SuperstarLiveBidding";
// import SuperstarLiveBiddingModal from "./Pages/Superstar-Souvenir/SuperstarLiveBidding/SuperstarLiveBiddingModal";
import SuperstarLiveBiddingCheckout from "./Pages/Superstar-Souvenir/SuperstarLiveBiddingCheckout/SueprstarLiveBiddingCheckout";
import SuperstarAudition from "./Pages/SuperstarAudition/SuperstarAudition";
import SuperstarAuditionLive from "./Pages/SuperstarAudition/SuperstarAuditionLive/SuperstarAuditionLive";
import SuperstarAuditionPending from "./Pages/SuperstarAudition/SuperstarAuditionPending/SuperstarAuditionPending";

// import StarPendingAudition from "./Pages/SuperstarAudition/StarPendingAudition/StarPendingAudition";
// import StarVideoPendingAudition from "./Pages/SuperstarAudition/StarVideoPendingAudition/StarVideoPendingAudition";
import liveVideoChat from "../../../src/LiveVideoChat";
import AllPromoVideos from "../../Screen/SuperStar/PromoVideo/AllPromoVideos";
import LivePromoVideo from "../../Screen/SuperStar/PromoVideo/LivePromoVideo";
import PendingPromoVideo from "../../Screen/SuperStar/PromoVideo/PendingPromoVideo";
import PendingVideoDetails from "./Pages/PromoVideos/PendingVideoDetails";
import StarGreetingsRegisteredList from "./Pages/StarGreetingsRegisteredList/StarGreetingsRegisteredList";
import SueprstarScheduleCreate from "./Pages/SueperstarSchedule/SueperstarScheduleCreate/SueperstarScheduleCreate";
import StarAudioVideoPending from "./Pages/SuperstarAudition/StarAudioVideoPending/StarAudioVideoPending";
import StarAuditionDescription from "./Pages/SuperstarAudition/StarAuditionDescription/StarAuditionDescription";
import SuperstarGreetingsForm from "./Pages/SuperstarPageGreetings/SuperstarGreetingsForm/SuperstarGreetingsForm";
// import StarGreetingsCompletedList from "./Pages/StarGreetingsCompletedList/StarGreetingsCompletedList";
import StarGreetingsCompletedList from "./Pages/StarGreetingsCompletedList/StarGreetingsCompletedList";
import StarGreetingsForwarderdedToUserList from "./Pages/StarGreetingsForwarderdedToUserList/StarGreetingsForwarderdedToUserList";

import StarMeetupEventEdit from "./Pages/MeetupEventsStar/StarMeetupEventEdit";
import EditPostStarAudition from "./Pages/SuperstarAudition/EditPostStarAudition";
import PendingPostDetailsStar from "./Pages/SuperstarAudition/PendingPostDetails";
import PendingPostStar from "./Pages/SuperstarAudition/PendingPostStar";
import PendingPromoAudition from "./Pages/SuperstarAudition/PendingPromoAudition";
import PromoInstructionSendInfo from "./Pages/SuperstarAudition/PromoInstructionSendInfo";

import AddPromoVideo from "../../Screen/SuperStar/PromoVideo/AddPromoVideo";

// Star Showcase -> Marketplace
import AddProductSuperstarFromMarketPlace from "../SuperStar/Pages/StarShowcase/Marketplace/AddProductSuperstarFromMarketPlace/AddProductSuperstarFromMarketPlace";
import SuperstarConfirmEditMarketplace from "../SuperStar/Pages/StarShowcase/Marketplace/SuperstarConfirmEditMarketplace/SuperstarConfirmEditMarketplace";
import SuperstarEditMarketPlaceForm from "../SuperStar/Pages/StarShowcase/Marketplace/SuperstarEditMarketPlaceForm/SuperstarEditMarketPlaceForm";
import SuperstarMarketplaceSouvenir from "../SuperStar/Pages/StarShowcase/Marketplace/SuperstarMarketplaceSouvenir";
import SuperstarProductList from "../SuperStar/Pages/StarShowcase/Marketplace/SuperstarProductList/SuperstarProductList";

// Star Showcase -> Souvenir
import DetailsSouvenirStar from "../SuperStar/Pages/StarShowcase/Souvenir/DetailsSouvenirStar";
import SouvenirPaymentDueList from "../SuperStar/Pages/StarShowcase/Souvenir/SouvenirPaymentDueList";
import SouvenirPaymentList from "../SuperStar/Pages/StarShowcase/Souvenir/SouvenirPaymentList";
import SouvenirRegisteredList from "../SuperStar/Pages/StarShowcase/Souvenir/SouvenirRegisteredList";
import SuperstarSouvenir from "../SuperStar/Pages/StarShowcase/Souvenir/SuperstarSouvenir";
import SouvenirCreateStar from "./Pages/StarShowcase/Souvenir/SouvenirCreateStar";
import SouvenirEditStar from "./Pages/StarShowcase/Souvenir/SouvenirEditStar";

import RejectedLearningSession from "../../Screen/SuperStar/LearningSession/RejectedLearningSession";

import RejectedPromoVideo from "../../Screen/SuperStar/PromoVideo/RejectedPromoVideo";

import SuperstarLiveNowAuction from "./Pages/StarShowcase/Auction/SuperstarLiveNowAuction";

import ApprovedPromoVideo from "../../Screen/SuperStar/PromoVideo/ApprovedPromoVideo";
import Settings from "../Admin/MainDashboard/Reuse/Settings";
import StarScheduleTable from "./MainDashboard/Screen/StarScheduleTable";
import StarSingleSchedule from "./MainDashboard/Screen/StarSingleSchedule";
import EditPromoVideo from "./Pages/PromoVideos/EditPromoVideo";
import CallDetails from "./Pages/StarLiveChat/CallDetails";
import SuperstarScheduleListMonthly from "./Pages/SueperstarSchedule/SuperstarScheduleList/SuperstarScheduleListMonthly";
import AuditiionRoundInstructionVideoDetails from "./Pages/SuperstarAudition/AuditiionRoundInstructionVideoDetails";
import StarRoundInstructionVideoCreate from "./Pages/SuperstarAudition/PostContentMaking/StarRoundInstructionVideoCreate";
import AcceptedPrmotionalVideoView from "./Pages/SuperstarAudition/PromotionalVideo/AcceptedPrmotionalVideoView";
import AuditionPromotionalList from "./Pages/SuperstarAudition/PromotionalVideo/AuditionPromotionalList";
import CreatePromo from "./Pages/SuperstarAudition/PromotionalVideo/CreatePromo";
import PrmotionalVideoView from "./Pages/SuperstarAudition/PromotionalVideo/PrmotionalVideoView";
import PromotionalList from "./Pages/SuperstarAudition/PromotionalVideo/PromotionalList";
import RoundInstructionVideo from "./Pages/SuperstarAudition/RoundInstructionVideo";
import RoundInstructionVideoAccepted from "./Pages/SuperstarAudition/RoundInstructionVideoAccepted";
import StarAuditionRoundInstructions from "./Pages/SuperstarAudition/StarAuditionRoundInstructions/StarAuditionRoundInstructions";
import StarAuditionRoundVideoMarking from "./Pages/SuperstarAudition/StarAuditionRoundVideoMarking/StarAuditionRoundVideoMarking";
import StarProfile from "./settings/StarProfile";
import StarLearningResult from "../../Screen/SuperStar/LearningSession/StarLearningResult";
import StarShowcase from "./MainDashboard/Screen/StarShowcase";
import MeetupContent from "./Pages/MeetupEventsStar/meetUpContent";
import E_WalletStar from "../../Screen/E_WalletStar";

const SuperstarRoute = [
  { path: "/superstar", exact: true, name: "SuperStar" },

  {
    path: "/superstar/dashboard",
    exact: true,
    name: "Dashboard",
    component: StarMainDashboard,
  },

  //Profile
  {
    path: "/superstar/profile",
    exact: true,
    name: "profile",
    component: StarProfile,
  },
  {
    path: "/superstar/star-showcase",
    exact: true,
    name: "star-showcase",
    component: StarShowcase,
  },
  {
    path: "/superstar/profile-settings",
    exact: true,
    name: "profile",
    component: Settings,
  },

  // Schedule
  {
    path: "/superstar/schedule/single",
    exact: true,
    name: "schedule",
    component: StarSingleSchedule,
  },
  {
    path: "/superstar/schedule/date/:id/:type",
    exact: true,
    name: "schedule",
    component: StarScheduleTable,
  },

  // Schedule Route ,
  {
    path: "/superstar/schedule-create",
    exact: true,
    name: "schedule-create",
    component: SueprstarScheduleCreate,
  },
  // { path: "/superstar/schedule-list", exact: true, name: "schedule-list", component: SuperstarScheduleList },
  {
    path: "/superstar/schedule-list",
    exact: true,
    name: "schedule-list",
    component: SuperstarScheduleListMonthly,
  },

  {
    path: "/superstar/event-date",
    exact: true,
    name: "Dashboard",
    component: StarDashEvent,
  },
  {
    path: "/superstar/event-category",
    exact: true,
    name: "Dashboard",
    component: StarEventCategory,
  },
  {
    path: "/superstar/event-requesting",
    exact: true,
    name: "Dashboard",
    component: StarEventRequesting,
  },
  {
    path: "/superstar/event-category/join",
    exact: true,
    name: "Dashboard",
    component: StarVideoJoin,
  },

  // Post Route
  {
    path: "/superstar/post",
    exact: true,
    name: "All-Post",
    component: AllPost,
  },
  {
    path: "/superstar/post/create",
    exact: true,
    name: "Create-Post",
    component: CreatePost,
  },
  {
    path: "/superstar/post/pending",
    exact: true,
    name: "Pending-Post",
    component: PendingPost,
  },
  {
    path: "/superstar/post/approved",
    exact: true,
    name: "Approved_Post",
    component: ApprovedPost,
  },
  {
    path: "/superstar/post/:id",
    exact: true,
    name: "Post-Details",
    component: PostDetails,
  },
  {
    path: "/superstar/post/edit/:id",
    exact: true,
    name: "Edit-Post",
    component: EditPost,
  },

  // Live Chat Section
  {
    path: "/superstar/live-chat",
    exact: true,
    name: "LiveChat",
    component: LiveChatContent,
  },
  {
    path: "/superstar/live-chat/create",
    exact: true,
    name: "edit_session",
    component: LiveChatCreate,
  },
  {
    path: "/superstar/live-chat/:type",
    exact: true,
    name: "LiveChat_pending_session",
    component: LiveChatType,
  },
  {
    path: "/superstar/live-chat/details/:id",
    exact: true,
    name: "LiveChat_pending_session",
    component: LiveChatDetails,
  },
  {
    path: "/superstar/live-chat/edit/:id",
    exact: true,
    name: "edit_session",
    component: LiveChatEdit,
  },

  {
    path: "/superstar/live-chat/schedule-list/:id",
    name: "Schedule_list",
    component: LiveChatScheduleList,
  },
  {
    path: "/superstar/live-chat-approve",
    exact: true,
    name: "live-chat-approve",
    component: StarLiveChatApprove,
  },
  {
    path: "/superstar/Live-chat/view",
    exact: true,
    name: "LiveChat_view",
    component: StarScheduleView,
  },
  {
    path: "/superstar/live-chat/approved-session/details/:id",
    exact: true,
    name: "LiveChat_pending_session",
    component: StarApprovedContentDetails,
  },
  {
    path: "/superstar/live-chat/join/:id",
    exact: true,
    name: "LiveChat_pending_session",
    component: JoinLiveChat,
  },
  {
    path: "/superstar/live-chat/pending-session/view/:id",
    exact: true,
    name: "LiveChat_pending_session",
    component: StarAddSessionContent,
  },

  // Question and Answers

  {
    path: "/superstar/qna/dashboard",
    exact: true,
    name: "qna-dashboard",
    component: QnaDashboard,
  },
  {
    path: "/superstar/qna/create",
    exact: true,
    name: "qna-event-create",
    component: QnACreate,
  },
  {
    path: "/superstar/qna/pending",
    exact: true,
    name: "qna-pending",
    component: PendingQnA,
  },
  {
    path: "/superstar/qna/live",
    exact: true,
    name: "Qna-Live",
    component: LiveQnA,
  },
  {
    path: "/superstar/qna/completed",
    exact: true,
    name: "qna-completed",
    component: QnaCompleted,
  },
  {
    path: "/superstar/qna/details/:id",
    exact: true,
    name: "qna-details",
    component: QnADetails,
  },
  //===== Qna message ui route start here ====
  {
    path: "/superstar/qna/QnaMsgBox",
    exact: true,
    name: "QnaMsgBox",
    component: QnaMsgBox,
  },
  //===== Qna message ui route end here =====
  {
    path: "/superstar/qna/edit/:id",
    exact: true,
    name: "qna-edit",
    component: StarEditQna,
  },

  //@FIXME: Audition
  {
    path: "/superstar/audition",
    exact: true,
    name: "auditions",
    component: SuperstarAudition,
  },
  {
    path: "/superstar/audition/pending",
    exact: true,
    name: "auditions",
    component: SuperstarAuditionPending,
  },
  {
    path: "/superstar/audition/live",
    exact: true,
    name: "auditions",
    component: SuperstarAuditionLive,
  },
  {
    path: "/superstar/audition/pending-post",
    exact: true,
    name: "auditions",
    component: PendingPostStar,
  },
  {
    path: "/superstar/audition/pending-post-details",
    exact: true,
    name: "auditions",
    component: PendingPostDetailsStar,
  },
  {
    path: "/superstar/audition/pending-promo-auditions",
    exact: true,
    name: "auditions",
    component: PendingPromoAudition,
  },
  {
    path: "/superstar/audition/promo-instruction-send-info/:id",
    exact: true,
    name: "auditions",
    component: PromoInstructionSendInfo,
  },
  {
    path: "/superstar/audition/approved-post-edit",
    exact: true,
    name: "auditions",
    component: EditPostStarAudition,
  },
  {
    path: "/superstar/auditions/pending/:id",
    exact: true,
    name: "auditions",
    component: StarAudioVideoPending,
  },
  {
    path: "/superstar/auditions/description/:audition_id",
    exact: true,
    name: "auditions-description",
    component: StarAuditionDescription,
  },
  {
    path: "/superstar/auditions/round-video-marking/:audition_id",
    exact: true,
    name: "round-instruction",
    component: StarAuditionRoundVideoMarking,
  },

  // By Srabon

  {
    path: "/superstar/audition/round-instruction-video",
    exact: true,
    name: "auditions",
    component: RoundInstructionVideo,
  },
  {
    path: "/superstar/audition/round-instruction-video-accepted",
    exact: true,
    name: "auditions",
    component: RoundInstructionVideoAccepted,
  },

  {
    path: "/superstar/auditions/round-instruction-video/:id",
    exact: true,
    name: "auditions",
    component: AuditiionRoundInstructionVideoDetails,
  },
  {
    path: "/superstar/auditions/round-instruction-video/create/:id",
    exact: true,
    name: "auditions-create",
    component: StarRoundInstructionVideoCreate,
  },
  {
    path: "/superstar/auditions/description/:audition_id",
    exact: true,
    name: "auditions-description",
    component: StarAuditionDescription,
  },
  {
    path: "/superstar/auditions/round-instruction/:audition_id",
    exact: true,
    name: "round-instruction",
    component: StarAuditionRoundInstructions,
  },

  //partha ghose
  {
    path: "/superstar/audition/promotional-post/:id",
    exact: true,
    name: "auditions",
    component: CreatePromo,
  },
  {
    path: "/superstar/audition/promotional-list",
    exact: true,
    name: "auditions",
    component: PromotionalList,
  },
  {
    path: "/superstar/audition/accepted-promotional-list",
    exact: true,
    name: "auditions",
    component: AuditionPromotionalList,
  },
  {
    path: "/superstar/audition/promotional-view/:id",
    exact: true,
    name: "auditions",
    component: PrmotionalVideoView,
  },
  {
    path: "/superstar/audition/accepted-promotional-view/:id",
    exact: true,
    name: "auditions",
    component: AcceptedPrmotionalVideoView,
  },

  // Learning Session

  {
    path: "/superstar/learning-session",
    exact: true,
    name: "learning-session",
    component: LearningSession,
  },

  {
    path: "/superstar/learning-session/pending",
    exact: true,
    name: "learning-session",
    component: PendingLearningSession,
  },
  {
    path: "/superstar/learning-session/rejected",
    exact: true,
    name: "learning-session",
    component: RejectedLearningSession,
  },
  // {
  //   path: "/superstar/learning-session/approved",
  //   exact: true,
  //   name: "ApprovedPost",
  //   component: ApprovedLearningSession,
  // },
  {
    path: "/superstar/learning-session/completed",
    exact: true,
    name: "Completed",
    component: CompletedLearningSession,
  },
  {
    path: "/superstar/learning-session/evaluation",
    exact: true,
    name: "ApprovedPost",
    component: EvaluationLearningSession,
  },
  {
    path: "/superstar/learning-session/evaluation/:id",
    exact: true,
    name: "learning-session",
    component: LearningSessionEvaluationDetails,
  },
  {
    path: "/superstar/learning-session/details/:id",
    exact: true,
    name: "learning-session",
    component: PendingLearningSessionDetails,
  },

  {
    path: "/superstar/learning-session/create",
    exact: true,
    name: "CreateLearningSession",
    component: CreateLearningSession,
  },
  {
    path: "/superstar/learning-session/pending",
    exact: true,
    name: "learning-session",
    component: PendingLearningSession,
  },
  {
    path: "/superstar/learning-session/rejected",
    exact: true,
    name: "learning-session",
    component: RejectedLearningSession,
  },
  {
    path: "/superstar/learning-session/approved",
    exact: true,
    name: "ApprovedPost",
    component: ApprovedLearningSession,
  },
  {
    path: "/superstar/learning-session/evaluation",
    exact: true,
    name: "ApprovedPost",
    component: EvaluationLearningSession,
  },
  {
    path: "/superstar/learning-session/evaluation/:slug",
    exact: true,
    name: "learning-session",
    component: LearningSessionEvaluationDetails,
  },

  {
    path: "/superstar/learning-session/edit/:id",
    exact: true,
    name: "CreatePost",
    component: EditLearningSession,
  },

  {
    path: "/superstar/learning-session/request",
    exact: true,
    name: "request",
    component: RequestLearn,
  },
  {
    path: "/superstar/learning-session/request-all",
    exact: true,
    name: "request-all",
    component: RequestLearnList,
  },
  {
    path: "/superstar/learning-session/request/event",
    exact: true,
    name: "event",
    component: RequestLearnEvent,
  },
  {
    path: "/superstar/learning-session/request/approved",
    exact: true,
    name: "approved",
    component: StarLearnSessionTime,
  },
  {
    path: "/superstar/learning-session/show-result",
    exact: true,
    name: "approved",
    component: StarLearningResult,
  },
  {
    path: "/superstar/notify/record",
    exact: true,
    name: "notify",
    component: NotifyRecord,
  },
  {
    path: "/superstar/notify-schedule",
    exact: true,
    name: "notify-schedule",
    component: StarNotifySchedule,
  },
  {
    path: "/superstar/notify-schedule/view",
    exact: true,
    name: "view",
    component: StartNotifyScheduleView,
  },
  // Greetings Route
  {
    path: "/superstar/greetings",
    exact: true,
    name: "greetings",
    component: SuperstarGreetings,
  },
  {
    path: "/superstar/greetings/greetingsForm",
    exact: true,
    name: "greetingsForm",
    component: SuperstarGreetingsForm,
  },
  {
    path: "/superstar/greetings-registered-list",
    exact: true,
    name: "greetingsRegistered",
    component: StarGreetingsRegisteredList,
  },
  {
    path: "/superstar/greetings-completed-list",
    exact: true,
    name: "greetingsCompleted",
    component: StarGreetingsCompletedList,
  },
  {
    path: "/superstar/greetings-forwarded-list",
    exact: true,
    name: "greetingsForwardedList",
    component: StarGreetingsForwarderdedToUserList,
  },
  {
    path: "/superstar/greetings/video-record/:greeting_registration_id",
    exact: true,
    name: "greetings",
    component: SuperstarGreetingsVideoRecord,
  },

  {
    path: "/superstar/greetings/video-upload",
    exact: true,
    name: "greetings",
    component: SuperstarGreetingsVideoUpload,
  },
  {
    path: "/superstar/upcoming-event",
    exact: true,
    name: "upcoming-event",
    component: StarUpcomingEvent,
  },

  // Meetup Event
  {
    path: "/superstar/meetup-events/dashboard",
    exact: true,
    name: "meetup-events",
    component: MeetupContent,
  },
  {
    path: "/superstar/meetup-events/create",
    exact: true,
    name: "meetup-events",
    component: StarMeetUpEventCreate,
  },
  {
    path: "/superstar/meetup-events/:type",
    exact: true,
    name: "meetup-events",
    component: StarMeetUpEventList,
  },

  {
    path: "/superstar/meetup-events/completed",
    exact: true,
    name: "meetup-events",
    component: StarMeetUpEventListCompleted,
  },
  {
    path: "/superstar/join-meetup-events/:id",
    exact: true,
    name: "join",
    component: JoinNoWMeetUp,
  },
  {
    path: "/superstar/meetup-events/details/:id",
    exact: true,
    name: "meetup-events",
    component: StarMeetUpEvent,
  },
  {
    path: "/superstar/meetup-events/edit/:id",
    exact: true,
    name: "meetup-events",
    component: StarMeetupEventEdit,
  },
  {
    path: "/superstar/star-video-chat/:id",
    exact: true,
    name: "star-video-chat",
    component: StarVideoChat,
  },

  // Fan Group
  {
    path: "/superstar/fan-group",
    exact: true,
    name: "fan-group",
    component: FanGroupHome,
  },
  {
    path: "/superstar/fan-group-accepted",
    exact: true,
    name: "fan-group-accepted",
    component: AcceptedFan,
  },
  {
    path: "/superstar/fan-group-rejected",
    exact: true,
    name: "fan-group-rejected",
    component: RejectedFan,
  },
  {
    path: "/superstar/fan-group-invitation",
    exact: true,
    name: "fan-group-invitation",
    component: InvitationFan,
  },

  {
    path: "/superstar/fan-group-live/:slug",
    exact: true,
    name: "fan-group-live",
    component: FanGroupLive,
  },
  {
    path: "/superstar/fan-group-invitation/details/:slug",
    exact: true,
    name: "details",
    component: InvitationDetails,
  },
  {
    path: "/superstar/fan-group-ignored/details/:slug",
    exact: true,
    name: "details",
    component: IgnoredDetails,
  },
  {
    path: "/superstar/fan-group-accepted/details/:slug",
    exact: true,
    name: "details",
    component: AcceptDetail,
  },

  // { path: '/superstar/fan-group-invitation/details', exact: true, name: 'details', component: InvitationDetails },
  {
    path: "/superstar/fan-group-invitation/edit/:slug",
    exact: true,
    name: "edit",
    component: FanGroupCreate,
  },
  {
    path: "/superstar/fan-group/accepted",
    exact: true,
    name: "accepted",
    component: AcceptedDetails,
  },
  {
    path: "/superstar/fan-group/rejected",
    exact: true,
    name: "rejected",
    component: RejectedDetails,
  },
  {
    path: "/superstar/fan-group-live",
    exact: true,
    name: "fan-group-live",
    component: FanGroupLive,
  },

  {
    path: "/superstar/fan-group/home/:slug",
    exact: true,
    name: "details",
    component: FanBaseStar,
  },

  // FanbaseAdmin1

  // Souvenir

  // <======================== Auction Route =====================

  {
    path: "/superstar/souvenir",
    exact: true,
    name: "superstar-souvenir",
    component: SuperstarSouvenir,
  },
  {
    path: "/superstar/souvenir/create",
    exact: true,
    name: "superstar-souvenir",
    component: SouvenirCreateStar,
  },
  {
    path: "/superstar/souvenir/edit/:id",
    exact: true,
    name: "superstar-souvenir",
    component: SouvenirEditStar,
  },
  {
    path: "/superstar/souvenir/details",
    exact: true,
    name: "superstar-souvenir",
    component: DetailsSouvenirStar,
  },
  {
    path: "/superstar/souvenir/register/list",
    exact: true,
    name: "superstar-souvenir",
    component: SouvenirRegisteredList,
  },
  {
    path: "/superstar/souvenir/payment/list",
    exact: true,
    name: "superstar-souvenir",
    component: SouvenirPaymentList,
  },
  {
    path: "/superstar/souvenir/payment/due-list",
    exact: true,
    name: "superstar-souvenir",
    component: SouvenirPaymentDueList,
  },

  // { path: "/superstar/auction", exact: true, name: "superstar-auction", component: SuperstarLiveNowAuction },
  {
    path: "/superstar/souvenir/add-products",
    exact: true,
    name: "superstar-souvenir-add-products",
    component: AddProductAuctionSuperstar,
  },
  {
    path: "/superstar/souvenir/confirm-or-edit-super-auction",
    exact: true,
    name: "superstar-souvenir-confirm-edit",
    component: ConfirmOrEditSuperAuction,
  },
  {
    path: "/superstar/souvenir/approvedOrDecline/:id",
    exact: true,
    name: "superstar-souvenir-approved-decline",
    component: ApprovedOrDecline,
  },

  {
    path: "/superstar/souvenir/superstar-live-biddings",
    exact: true,
    name: "superstar-souvenir-live-bidding",
    component: SuperstarLiveBidding,
  },
  {
    path: "/superstar/souvenir/superstar-live-biddings-checkout",
    exact: true,
    name: "superstar-souvenir-live-bidding",
    component: SuperstarLiveBiddingCheckout,
  },

  //
  {
    path: "/superstar/auction",
    exact: true,
    name: "superstar-auction",
    component: SuperstarLiveNowAuction,
  },
  {
    path: "/superstar/auction/add-products",
    exact: true,
    name: "superstar-auction-add-products",
    component: AddProductAuctionSuperstar,
  },
  {
    path: "/superstar/auction/confirm-or-edit-super-auction/:id",
    exact: true,
    name: "superstar-auction-confirm-edit",
    component: ConfirmOrEditSuperAuction,
  },
  {
    path: "/superstar/auction/approvedOrDecline/:id",
    exact: true,
    name: "superstar-auction-approved-decline",
    component: ApprovedOrDecline,
  },
  {
    path: "/superstar/auction/edit/:id",
    exact: true,
    name: "superstar-auction-edit",
    component: EditProductAuction,
  },

  // { path: '/superstar-admin/souvenir/confirm-or-edit-super-auction', exact: true, name: 'superstar-souvenir-auction', component: SuperstarLiveBiddingModal },
  // { path: "/superstar/souvenir/superstar-live-biddings", exact: true, name: "superstar-souvenir-live-bidding", component: SuperstarLiveBidding },
  // { path: "/superstar/souvenir/superstar-live-biddings-checkout", exact: true, name: "superstar-souvenir-live-bidding", component: SuperstarLiveBiddingCheckout },

  {
    path: "/superstar/auction-product-list/pending",
    exact: true,
    name: "superstar-auction-pending",
    component: PendingProductList,
  },
  {
    path: "/superstar/auction-product-list/unSold",
    exact: true,
    name: "superstar-auction-unsold",
    component: UnSoldProductList,
  },
  {
    path: "/superstar/auction-product-list/sold",
    exact: true,
    name: "superstar-auction-sold",
    component: SoldProductList,
  },

  //<========================= End Auction Route ==========================

  //<========================= Star Showcase -> Marketplace Route ==========================

  {
    path: "/superstar/marketplace",
    exact: true,
    name: "superstar-marketplace",
    component: SuperstarMarketplaceSouvenir,
  },
  {
    path: "/superstar/add-products-marketPlace",
    exact: true,
    name: "superstar-souvenir-live-bidding",
    component: AddProductSuperstarFromMarketPlace,
  },
  {
    path: "/superstar/confirm-or-edit-marketplace/:id",
    exact: true,
    name: "superstar-souvenir-live-bidding",
    component: SuperstarConfirmEditMarketplace,
  },
  {
    path: "/superstar/product-list/pending",
    exact: true,
    name: "superstar-souvenir-live-bidding",
    component: SuperstarProductList,
  },
  {
    path: "/superstar/product-list/approved",
    exact: true,
    name: "superstar-souvenir-live-bidding",
    component: SuperstarProductList,
  },
  {
    path: "/superstar/edit-marketplace/:id",
    exact: true,
    name: "superstar-souvenir-live-bidding",
    component: SuperstarEditMarketPlaceForm,
  },
  //<========================= End Marketplace Route ==========================

  {
    path: "/superstar/live-chat/stream/:slug",
    exact: true,
    name: "superstar-live-chat",
    component: liveVideoChat,
  },
  {
    path: "/superstar/videocall",
    exact: true,
    name: "superstar-learning-session-live-stream",
    component: LearningSessionLiveStream,
  },

  // Promo Videos

  {
    path: "/superstar/promo-videos",
    exact: true,
    name: "promo-videos",
    component: AllPromoVideos,
  },
  {
    path: "/superstar/upload/promoVideo",
    exact: true,
    name: "createPromo",
    component: AddPromoVideo,
  },
  {
    path: "/superstar/pending/promoVideo",
    exact: true,
    name: "pendingPromo",
    component: PendingPromoVideo,
  },
  {
    path: "/superstar/approved/promoVideo",
    exact: true,
    name: "pendingPromo",
    component: ApprovedPromoVideo,
  },
  {
    path: "/superstar/edit/promoVideo/:id",
    exact: true,
    name: "editPromo",
    component: EditPromoVideo,
  },
  {
    path: "/superstar/live/promoVideo",
    exact: true,
    name: "pendingPromo",
    component: LivePromoVideo,
  },
  {
    path: "/superstar/rejected/promoVideo",
    exact: true,
    name: "RejectedPromo",
    component: RejectedPromoVideo,
  },
  {
    path: "/superstar/pending/videoDetails/:id",
    exact: true,
    name: "pendingPromo",
    component: PendingVideoDetails,
  },
  // call Details route
  {
    path: "/superstar/callDetails",
    exact: true,
    name: "callDetails",
    component: CallDetails,
  },
  {
    path: "/superstar/e-wallet",
    exact: true,
    name: "e-wallet",
    component: E_WalletStar,
  },
];

export default SuperstarRoute;
